module.exports = {
	"accessRemoved": "Accès retiré.",
	"inviteCancelled": "Invitation annulée.",
	"inviteSent": "Invitation envoyée.",
	"listCreated": "Liste créee.",
	"listRemoved": "Liste retirée."
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/oa-ajax.json5
// module id = 1994
// module chunks = 6